"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var web3_1 = __importDefault(require("web3"));
var Http = require('web3-providers-http');
var Websocket = require('web3-providers-ws');
var async_mutex_1 = require("async-mutex");
var Loader_1 = __importDefault(require("./Loader"));
var Web3Environment = (function () {
    function Web3Environment(providerConfig, deploymentContextConfig) {
        this.providerConfig = providerConfig;
        this.deploymentContextConfig = deploymentContextConfig;
        this.cachedProviders = {};
        this.cachedWrappedProviders = {};
        this._providersCacheMutex = new async_mutex_1.Mutex();
        this._wrappedProvidersCacheMutex = new async_mutex_1.Mutex();
        console.debug("Web3Environment for '" + providerConfig.name + "' created.", "Supported contracts: " + Object.keys(deploymentContextConfig.contracts).join(', '));
    }
    Web3Environment.get = function (providerConfig, deploymentContextConfig) {
        return __awaiter(this, void 0, void 0, function () {
            var loader;
            return __generator(this, function (_a) {
                loader = new Loader_1.default();
                return [2, loader.loadEnvironment(providerConfig, deploymentContextConfig)];
            });
        });
    };
    Web3Environment.prototype.getWrappedProvider = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                options = options || this.providerConfig.options || {};
                return [2, this._getCachedWrappedProvider(this.providerConfig.url, options)];
            });
        });
    };
    Web3Environment.prototype.getWeb3 = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, this.getWrappedProvider(options)];
            });
        });
    };
    Web3Environment.prototype.getContract = function (contractName, web3) {
        return __awaiter(this, void 0, void 0, function () {
            var contractOverride, url, options, contract, abi;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!web3) return [3, 2];
                        contractOverride = this.providerConfig.contracts
                            ? this.providerConfig.contracts[contractName]
                            : undefined;
                        url = contractOverride ? contractOverride.url : this.providerConfig.url;
                        options = (contractOverride ? contractOverride.options : this.providerConfig.options) || {};
                        return [4, this._getCachedWrappedProvider(url, options)];
                    case 1:
                        web3 = _a.sent();
                        _a.label = 2;
                    case 2:
                        contract = this.deploymentContextConfig.contracts[contractName];
                        if (typeof contract.abi === 'string') {
                            abi = require("../../abis/" + contract.abi);
                            contract.abi = abi;
                        }
                        return [2, new web3.eth.Contract(contract.abi, contract.address)];
                }
            });
        });
    };
    Web3Environment.prototype.shutdown = function () {
        return __awaiter(this, void 0, void 0, function () {
            var providerLockRelease, wrappedProviderLockRelease, _i, _a, _b, url, provider;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        console.debug("Disconnecting environment " + this.providerConfig.name + " ...");
                        return [4, this._providersCacheMutex.acquire()];
                    case 1:
                        providerLockRelease = _c.sent();
                        return [4, this._wrappedProvidersCacheMutex.acquire()];
                    case 2:
                        wrappedProviderLockRelease = _c.sent();
                        for (_i = 0, _a = Object.entries(this.cachedProviders); _i < _a.length; _i++) {
                            _b = _a[_i], url = _b[0], provider = _b[1];
                            try {
                                console.debug("Disconnecting provider for " + url + " ...");
                                if (provider instanceof Http) {
                                    provider.disconnect(null, null);
                                }
                                else if (provider instanceof Websocket) {
                                    provider.disconnect(null, null);
                                }
                                else {
                                    console.warn("Unknown provider type for " + url);
                                }
                            }
                            catch (e) {
                                console.error("Error while disconnecting " + url + ":", e);
                            }
                        }
                        this.cachedProviders = {};
                        this.cachedWrappedProviders = {};
                        providerLockRelease();
                        wrappedProviderLockRelease();
                        console.debug("Environment " + this.providerConfig.name + " disconnected");
                        return [2];
                }
            });
        });
    };
    Web3Environment.prototype._getCachedProvider = function (url, options) {
        return __awaiter(this, void 0, void 0, function () {
            var providerLockRelease;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.cachedProviders[url] === undefined)) return [3, 2];
                        return [4, this._providersCacheMutex.acquire()];
                    case 1:
                        providerLockRelease = _a.sent();
                        try {
                            if (this.cachedProviders[url] === undefined) {
                                if (url.indexOf('http://') !== -1 || url.indexOf('https://') !== -1) {
                                    this.cachedProviders[url] = new Http(url, options);
                                }
                                else if (url.indexOf('ws://') !== -1) {
                                    this.cachedProviders[url] = new Websocket(url, options);
                                }
                                console.debug("New provider cached with key '" + url + "'");
                            }
                        }
                        catch (e) {
                            console.error(e);
                        }
                        finally {
                            providerLockRelease();
                        }
                        _a.label = 2;
                    case 2: return [2, this.cachedProviders[url]];
                }
            });
        });
    };
    Web3Environment.prototype._getCachedWrappedProvider = function (url, options) {
        return __awaiter(this, void 0, void 0, function () {
            var key, wrappedProviderRelease, provider, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        key = url + "." + JSON.stringify(options);
                        if (!(this.cachedWrappedProviders[key] === undefined)) return [3, 7];
                        return [4, this._wrappedProvidersCacheMutex.acquire()];
                    case 1:
                        wrappedProviderRelease = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 5, 6, 7]);
                        if (!(this.cachedWrappedProviders[key] === undefined)) return [3, 4];
                        return [4, this._getCachedProvider(url, options)];
                    case 3:
                        provider = _a.sent();
                        this.cachedWrappedProviders[key] = new web3_1.default(provider);
                        console.debug("New Web3 cached with key '" + key + "'");
                        _a.label = 4;
                    case 4: return [3, 7];
                    case 5:
                        e_1 = _a.sent();
                        console.error(e_1);
                        return [3, 7];
                    case 6:
                        wrappedProviderRelease();
                        return [7];
                    case 7: return [2, this.cachedWrappedProviders[key]];
                }
            });
        });
    };
    return Web3Environment;
}());
exports.default = Web3Environment;
//# sourceMappingURL=Environment.js.map